/**
 * bot-channels-lib.ts — Phần THUẦN của ô "Kênh phụ trách" (bot-channels-field.tsx): kênh nào đang giao cho ai.
 */
import type { AiBot } from '@/hooks/use-ai'
import { i18n } from '@/lib/i18n'

export interface ChannelRow {
  id: string
  name: string
  platform: number
  checked: boolean
  /** Tên nhân viên AI KHÁC đang được giao riêng kênh này (chọn = chuyển sang nhân viên này). */
  ownerName: string | null
  /** Kênh chưa giao cho ai → nhân viên AI mặc định đang phụ trách. */
  viaDefault: boolean
}

/** Danh sách kênh cho ô "Kênh phụ trách" của một nhân viên AI. */
export function channelRows(
  channels: Array<{ id: string; displayName: string | null; platform: number }>,
  bots: Array<Pick<AiBot, 'id' | 'name' | 'channelAccountIds'>>,
  self: { id: string; channelAccountIds: string[] },
): ChannelRow[] {
  return channels.map((c) => {
    const owner = bots.find((b) => b.id !== self.id && (b.channelAccountIds ?? []).includes(c.id))
    return {
      id: c.id,
      name: c.displayName || i18n.t('aiComp:botChannels.unnamed'),
      platform: c.platform,
      checked: self.channelAccountIds.includes(c.id),
      ownerName: owner?.name ?? null,
      viaDefault: !owner && !self.channelAccountIds.includes(c.id),
    }
  })
}

export const toggleId = (ids: string[], id: string, on: boolean) => (on ? (ids.includes(id) ? ids : [...ids, id]) : ids.filter((x) => x !== id))
